/**
 * A hook to provide data/callbacks for:
 *
 * - url
 * - ssoToken
 * - handleClick
 * - isSSOEnabled
 * - isAgentLoginEnabled
 *
 * @module
 */
import { useMemo } from 'react';
import Cookies from 'js-cookie';
import { getTokenName, getSsoEnabled, getAgentLoginEnabled, } from '../utils/globals';
import { getSsoUrl, getAgentLoginUrl } from '../utils/routes';
import { SSO_RETURN_URL_KEY } from '../utils/config';
const LOGOUT_URL = '/sso/logout';
/**
 * # useAuth
 *
 * Usage example:
 *
 * ```javascript
 * import { useAuth } from "@elevio/kb-kit/lib/hooks";
 *
 * const PageWithAuth = () => {
 *   const {
 *     handleClick,
 *     isAgentLoginEnabled,
 *     isSSOEnabled,
 *     ssoToken,
 *     url,
 *   } = useAuth();
 *
 *   console.log(url); // string
 *   console.log(ssoToken); // string
 *
 *   return (
 *     <div>
 *       <div>isSSOEnabled: {isSSOEnabled}</div>
 *       <div>isAgentLoginEnabled: {isAgentLoginEnabled}</div>
 *       <button onClick={handleClick}>Login</button>
 *     </div>
 *   );
 * };
 * ```
 */
export function useAuth({ onlyShowLogin, agentLogin, } = {}) {
    const tokenName = getTokenName(window.cname, window.subdomain);
    const ssoToken = useMemo(() => Cookies.get(tokenName), [tokenName]);
    const isAgentLoginEnabled = getAgentLoginEnabled();
    const isLogingIn = !ssoToken || onlyShowLogin;
    let url;
    let handleClick;
    if (isLogingIn) {
        url = agentLogin && isAgentLoginEnabled ? getAgentLoginUrl() : getSsoUrl();
        handleClick = (e) => {
            e.preventDefault();
            Cookies.set(SSO_RETURN_URL_KEY, window.location.href);
            window.location.href = url;
        };
    }
    else {
        url = LOGOUT_URL;
        handleClick = (e) => {
            e.preventDefault();
            Cookies.remove(tokenName);
            window.location.href = LOGOUT_URL;
        };
    }
    return {
        url,
        ssoToken,
        handleClick,
        isSSOEnabled: getSsoEnabled(),
        isAgentLoginEnabled,
    };
}
//# sourceMappingURL=useAuth.js.map